import { Draw } from "ol/interaction";
import { createBox } from "ol/interaction/Draw";
import { Style, Fill, Stroke } from "ol/style";
import { BaseInteraction } from "../../lib/interaction/interactions";
import { Maybe, Some } from "../../lib/misc/option";
import { ToolMessage } from "../messages/ToolMessage";
import { Switchboard } from "../../lib/events";
export class ZoomInteraction extends BaseInteraction {
    constructor(map, layer) {
        super();
        this.map = map;
        this.layer = layer;
        this.broadcaster = Switchboard.get_emitter("INTERACTION");
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.name = 'zoom';
        this.enter_context = new Some('toolbar');
        this.exit_context = new Some('revert');
    }
    get geometric() { return true; }
    init() {
        super.init();
        let draw = this.create_draw();
        this.attach_abort_handler(draw);
        this.interactions.push(draw);
        new ToolMessage({ selected: true, tool: this.name, command: "TOOL SELECTION" }).send();
    }
    remove() {
        super.remove();
        this.remove_abort_handler();
        new ToolMessage({ selected: false, tool: this.name, command: "TOOL SELECTION" }).send();
    }
    create_draw() {
        const draw = new Draw({
            type: "Circle",
            geometryFunction: createBox(),
            source: this.layer.source,
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 204, 51, 0.5)',
                    lineDash: [10, 10],
                    width: 2
                }),
            })
        });
        draw.on('drawend', this.draw_end_handler.bind(this));
        draw.on('drawabort', () => {
            this.cleanup_after_abort();
        });
        if (this.map.getTargetElement()) {
            this.map.getTargetElement().style.cursor = "zoom-in";
        }
        return draw;
    }
    draw_end_handler(evt) {
        let sketch = evt.feature;
        const geo = Maybe(sketch.getGeometry());
        geo.map(geometry => {
            this.map.getView().fit(geometry.getExtent(), { padding: [100, 100, 100, 100] });
            setTimeout(() => this.layer.clear(), 20);
        });
    }
    attach_abort_handler(draw) {
        $(window).on('keyup', (evt) => {
            if (evt.key == "Escape") {
                draw.abortDrawing();
                this.cleanup_after_abort();
            }
        });
        this.map.getViewport().addEventListener('pointerdown', (evt) => {
            if (evt.button === 2) {
                draw.abortDrawing();
            }
        });
    }
    remove_abort_handler() {
        $(window).off('keyup');
        this.map.getViewport().removeEventListener('pointerdown', () => { });
    }
    cleanup_after_abort() {
        if (this.map.getTargetElement()) {
            this.map.getTargetElement().style.cursor = 'default';
        }
        this.remove_abort_handler();
        this.broadcaster.emit('i_request', '');
        this.emitter.emit('ctx_request', 'singleton');
    }
}
